const bazarListCn = {
  banner: {
    title: '集市',
    subtitle: '从数千个传统乡村市场购物',
    breadcrumbLabel: '集市',
    currentPlaceholder: '搜索食品...'
  },
  filter: {
    title: '筛选选项',
    searchPlaceholder: '搜索集市...',
    district: '地区',
    upazilla: '县',
    size: '集市规模',
    sortBy: '排序方式',
    sortOptions: {
      name: '名称',
      storeCount: '商店数量',
      rating: '评分',
      visitors: '人气'
    },
    clearShort: '清除',
    clearAll: '清除全部',
    activeFilters: '活跃筛选器:',
    labels: {
      search: '搜索',
      district: '地区',
      upazilla: '县',
      size: '规模'
    }
  },
  results: {
    foundSuffix: '个集市找到',
    none: '未找到集市',
    page: '页'
  },
  empty: {
    title: '没有集市匹配您的搜索',
    subtitle: '尝试不同的筛选器或清除所有筛选器',
    clear: '清除所有筛选器'
  },
  card: {
    stores: '商店',
    dailyVisitors: '每日访客',
    specialties: '特色:',
    details: '详情',
    visit: '访问'
  },
  dialog: {
    title: '恭喜！',
    selected: '您的集市已被选择',
    instruction: '您当前的集市现已选择。从下面选择您想要购买的商品类别:',
    categoryPrompt: '您想要购买什么？',
    bottomNotePrefix: '这些产品将来自',
    bottomNoteSuffix: '',
    close: '稍后查看'
  }
};

export default bazarListCn;
